export default __webpack_public_path__ + "static/media/modak.e804710f.gif";